// @ts-nocheck
import React, { FunctionComponent } from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider as StyledProvider } from "styled-components";
import theme from "./styles/theme";

import { Router, Route, Switch, BrowserRouter } from "react-router-dom";
import history from "./history";

import store from "./store";

import style from "./styles/main.module.scss";
import LoginPage from "./Containers/Login/Login";
import MainPage from "./Containers/MainPage/MainPage";
import ErrorPage from "./Containers/Error/Error";
import AdminPage from "./Containers/AdminPage/AdminPage";
import DevicePage from "./Containers/SimpleDevice/SimpleDevices";
import Device2 from "./Containers/Devices/Devices";
import Device3 from "./Containers/DeviceQueue/DeviceQueue";
import Register from "./Containers/Register/Register";
import Profile from "./Containers/Profile";
import ControllerPage from "./Containers/Controller/Controller";
import Management from "./Containers/Management";
import Dialog from "./Containers/Dialog/Dialog";
import Translation from "./Components/Translation/Translation";
import Statistics from "./Containers/Statistics";

import Debug from "./Components/Debug/Debug";

import { QRCode } from "./Components/QRCode/QRCode";
import TestQRCode from "./Components/TestQRC/TestQRCode";

import Settings from "./Containers/Settings/Settings";

export const App: FunctionComponent<{}> = () => {
  return(<div className={style["main-wrapper"]}>
      <BrowserRouter history={history} >
        <Switch>
          <Route exact={true} path="/" render={(props) => window.location.replace("login")} />
          <Route exact={true} path="/map" component={MainPage} />
          <Route exact={true} path="/login" component={LoginPage} />
          <Route exact={true} path="/admin" component={AdminPage} />
          <Route exact={true} path="/management" component={Management} />
          <Route exact={true} path="/controller/:deviceId?" component={ControllerPage} />
          <Route exact={true} path="/device/:deviceId?" component={DevicePage} />
          <Route exact={true} path="/device2/:deviceId?" component={Device2} />
          <Route exact={true} path="/device3/:deviceId?" component={Device3} />
          <Route exact={true} path="/register/:deviceId?" component={Register} />
          <Route exact={true} path="/settings/:deviceId?" component={Settings} />
          <Route exact={true} path="/statistics/:deviceId?" component={Statistics} />
          <Route exact={true} path="/qrcode" component={QRCode} />
          {/* <Route exact={true} path="/greenpass" component={TestQRCode} /> */}
          <Route exact={true} path="/debug" component={Debug} />
          <Route exact={true} path="/profile" component={Profile} />
          <Route path="*" component={ErrorPage} />
        </Switch>
        <Dialog />
      </BrowserRouter>
  </div>);
};

render(
  <Provider store={store}>
    <Translation>
      <ThemeProvider theme={theme}>
        <StyledProvider theme={theme}>
          <App/>
        </StyledProvider>
      </ThemeProvider>
    </Translation>
  </Provider>, document.getElementById("root"),
);
